import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import ButtonTabs from '../../../../core/modules/common/components/ButtonTabs';
import Button from '../../../../core/modules/common/components/Button';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import { getSelectionCriteria, getReporting } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData, reportClearData } from '../redux/actions/ReportsActions';
import { pushHistory } from '../../../../core/modules/common/tools/HistoryTools';
import Modal from '../../../../core/modules/common/components/Modal';

class ReportsNavigationButtonTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  canFetchData = (reportId) => {
    const report = this.props.reporting[reportId];
    const data = (report === undefined) ? [] : report.data;
    return data.length === 0 || this.props.forceDataFetch;
  };

  navigateToReport = (value) => {
    const reportDefinition = ReportDefinitions[value];
    const reportId = reportDefinition.id;
    if (this.canFetchData(reportId)) {
      if (this.props.tabs.find(tab => tab.value === value).loadFromTable) {
        this.toggleModal();
        return;
      }
      this.props.reportLoadData(
        reportDefinition,
        this.props.reporting[reportId].mainReportId,
        new SelectionCriteriaDto(this
          .props.selectionCriteria, reportDefinition.selectionCriteria.items),
      );
    }
    pushHistory(`/report-wizard/${reportId}/report`);
    // localizedPushHistory(`/report-wizard/${reportId}/report`);
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showModal: !this.state.showModal,
    });
  };

  render() {
    return (
      <div>
        <ButtonTabs
          tabs={this.props.tabs}
          activeTab={this.props.activeTab}
          activePage={this.props.activePage}
          onChange={this.navigateToReport}
        />
        {this.state.showModal && (
          <Modal
            header={
              <FormattedMessage
                id={(this.props.tabs.find(tab => tab.loadFromTable) || {}).loadFromTableMessage}
                tagName="h4"
              />
            }
            closeOnOutsideClick
            onClose={this.toggleModal}
          >
            <div className="button-container">
              <Button text="app.button.ok" onClick={this.toggleModal} />
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

ReportsNavigationButtonTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
    loadFromTable: PropTypes.bool,
    loadFromTableMessage: PropTypes.string,
  })),
  forceDataFetch: PropTypes.bool,
  activeTab: PropTypes.string,
  reportLoadData: PropTypes.func,
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  reporting: PropTypes.objectOf(PropTypes.shape),
  activePage: PropTypes.number,
};
const mapStateToProps = (state, props) => ({
  reporting: getReporting(state),
  isLoading: props.isLoading,
  selectionCriteria: getSelectionCriteria(state),
});

const mapDispatchToProps =
    dispatch => bindActionCreators({ reportLoadData, reportClearData }, dispatch);

export const ConnectedReportsNavigationButtonTabs =
  connect(mapStateToProps, mapDispatchToProps)(ReportsNavigationButtonTabs);

export default (ConnectedReportsNavigationButtonTabs);
